@if (faIcon(); as faIcon) {
  <i [class]="clickable() ? 'cursor-pointer' : ''" [ngClass]="classes()" [ngStyle]="styles()"></i>
}
@if (assetIcon(); as assetIcon) {
  <img [src]="assetIcon" [class]="clickable() ? 'cursor-pointer' : ''" [ngClass]="classes()" [ngStyle]="styles()" />
}
